module.exports = __webpack_public_path__ + "static/media/report.eb12558b.svg";